import { Patients } from ".";
import { Users } from "./users";
import { Personnel } from "./personnel";

export class PrescriptionDialyse {
  id: number;
  datePrescription: any;
  isUrgent: boolean;
  libelle: string;
  patient: Patients;
  user: Users;
  medecin: Personnel;
}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/models/prescription-dialyse.ts